<template>
  <div v-if="theme" :title="theme.name" class="color-swatch">
    <span v-for="color in theme.colors" :key="color" :style="{backgroundColor: color}" class="color" />
  </div>
</template>

<script>
export default {
  name: 'ColorSwatch',
  props: ['theme']
}
</script>

<style lang="scss" scoped>
@import "~~/assets/css/components";

$color-border-radius: 6px;
$border-width: 3px;

.color-swatch {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  border-radius: calc($color-border-radius + $border-width);
  flex-grow: 1;
  border: $border-width solid var(--med-blue);

  .color {
    display: block;
    height: 40px;
    width: auto;
    flex-grow: 1;
    &:first-child {
      border-top-left-radius: $color-border-radius;
      border-bottom-left-radius: $color-border-radius;
    }
    &:last-child {
      border-top-right-radius: $color-border-radius;
      border-bottom-right-radius: $color-border-radius;
    }
  }
}
</style>
